import { Link } from 'react-router-dom';
import { SiteFooter, SiteHeader } from '../components/SiteChrome';

/**
 * Unknown paths used to redirect to the landing page, so a mistyped link
 * looked like a working one. Amplify still rewrites every unknown path to
 * `index.html`; this is what the SPA shows once it gets there.
 */
export function NotFound() {
  return (
    <div className="page">
      <div className="grid" />
      <SiteHeader active={null} />
      <div className="hn">
        <h1>Page not found</h1>
        <p className="lede">
          Nothing lives at this address. Try the <Link to="/">alerts</Link>, the{' '}
          <Link to="/terminal">terminal</Link> or the <Link to="/honest-numbers">honest numbers</Link>.
        </p>
      </div>
      <SiteFooter />
    </div>
  );
}
